import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import CodiceFiscale from 'codice-fiscale-js';

@Component({
  selector: 'app-calcolo-codicefs',
  templateUrl: './calcolo-codicefs.component.html',
  styleUrls: ['./calcolo-codicefs.component.css']
})
export class CalcoloCodicefsComponent implements OnInit {

  @Output() cfCalculated: EventEmitter<string> = new EventEmitter<string>();

  form: FormGroup = this.formBuilder.group({
    name: ['', Validators.required],
    surname: ['', Validators.required],
    birthDate: ['', Validators.required],
    gender: ['', Validators.required],
    italian: ['', Validators.required],
    birthPlace: ['', Validators.required]
  });

  constructor(private formBuilder: FormBuilder) {
  }

  ngOnInit(): void {
  }

  onSubmit(): void {
    if (this.form.invalid) {
      return;
    }
    const city = this.form.value.birthPlace.trim();
    const name = this.form.value.name.trim();
    const family = this.form.value.surname.trim();
    const sex = this.form.value.gender.trim();
    const isBornItaly = this.form.value.italian.trim();
    const birthday = this.form.value.birthDate.trim();

    console.log(birthday);

    try {
      if (!city || !name || !family || !sex || !isBornItaly || !birthday) {
        return;
      }
      let year;
      let month;
      let day;
      const ms = Date.parse(birthday);
      const date = new Date(ms);
      if (!!date.valueOf()) {
        // Valid date
        year = date.getFullYear();
        month = date.getMonth() + 1;
        day = date.getDate();
      } else {
        /* Invalid date */
        return;
      }
      const cf = new CodiceFiscale({
        name,
        surname: family,
        gender: sex,
        day,
        month,
        year,
        birthplace: city
      });
      this.cfCalculated.emit(cf.cf);
    } catch (err) {
      console.log(err);
      return;
    }
  }
}
